import { useEffect } from "react";
import { Card } from "../components/Card/Card";
import { Container } from "../components/Container/Container";
import { CTASection } from "../components/CTASection/CTASection";
import { PageHeader } from "../components/PageHeader/PageHeader";
import { Section } from "../components/Section/Section";
import { setPageMeta } from "../utils/metadata";
import * as styles from "./pages.css";

export function About() {
  useEffect(() => {
    setPageMeta(
      "About",
      "Ayro Technologies is a Nottinghamshire-based IT consulting business focused on practical technical advice, bespoke software, and delivery support."
    );
  }, []);

  return (
    <>
      <PageHeader
        eyebrow="About Ayro"
        title="A practical technology partner for organisations that need clarity and delivery."
        intro="Ayro Technologies is built around pragmatic technical judgement: understanding the problem, reducing uncertainty, and helping teams deliver systems that work."
      />
      <Section>
        <Container>
          <div className={styles.split}>
            <div>
              <h2 className={styles.sectionTitle}>How we work</h2>
              <p className={styles.mutedText}>
                We combine consulting, assessment, engineering, and project control so
                advice does not stop at a slide deck. The focus is always on the next
                useful decision and the work needed to make it real.
              </p>
            </div>
            <div className={styles.gridTwo}>
              <Card title="Decision discipline">
                <p>
                  We frame options, trade-offs, dependencies, and risks so leadership can
                  make technical decisions with confidence.
                </p>
              </Card>
              <Card title="Delivery assurance">
                <p>
                  We keep delivery connected to scope, quality gates, ownership, and the
                  business outcome the work is meant to support.
                </p>
              </Card>
              <Card title="Practical governance">
                <p>
                  We introduce just enough control to manage cost, security, dependencies,
                  and change without slowing teams down.
                </p>
              </Card>
              <Card title="Accountable execution">
                <p>
                  We make owners, decisions, risks, and next steps visible so projects can
                  move forward without ambiguity.
                </p>
              </Card>
            </div>
          </div>
        </Container>
      </Section>
      <CTASection />
    </>
  );
}
